<template>
    <div>
        <ss-gym-form v-model="form"
                     :formTitle="$t('update_gym_title')"
                     :submitTitle="$t('update')"
                     :errors="form.errors"
                     @published="changePublished"
                     @typeUrl="changeTypeUrl"
                     @submit="submit"></ss-gym-form>
    </div>
</template>

<script>
    import Form from 'vform';
    import {mapGetters} from 'vuex';
    import ssGymForm from './form/form.vue';
    import _ from 'lodash';

    export default {
        props: {
            id: {
                type: String,
                default: function() {
                    return '';
                }
            }
        },

        components: { ssGymForm },

        data: function () {
            return {
                form: new Form({
                    id: '',
                    location: {
                        country: null,
                        region: null,
                        city: null
                    },
                    title: '',
                    email: '',
                    phone: '',
                    web_hostname: {
                        name: '',
                        type: true
                    },
                    url_type: '',
                    address: '',
                    work_hours: '',
                    description: '',
                    is_published: true
                })
            }
        },

        computed: {
            ...mapGetters({
                getGymById: 'getGymById',
                userId: 'authUserId',
                getNewGym: 'getNewGym'
            }),

            async gym() {
                return this.getGymById;
            },
            fillingFields() {
                this.form.keys().forEach(key => {
                    this.form[key] = this.getGymById[key];
                });
                this.form.originalData = this.getGymById;
            }
        },

        async created() {
            await this.$store.dispatch('getGyms', this.userId);
            this.$store.dispatch('getGymById', this.id);
            this.fillingFields;
        },

        methods: {
            changePublished(data) {
                this.form.is_published = data.value;
            },

            changeTypeUrl(data) {
                this.form.web_hostname.type = data;
            },

            async submit() {
                this.form.city_id = this.form.location.city ? this.form.location.city.id : '';
                this.form.url_ident = this.form.web_hostname.name ? this.form.web_hostname.name : '';
                this.form.url_type = this.form.web_hostname.type === true ? 'local' : 'external';

                const {data} = await this.form.patch('/api/gyms/' + this.form.id);

                await this.$store.dispatch('updateGym', {gym: data});

                if (_.isObject(this.getNewGym)) {
                    this.$notify({
                        title: '',
                        type: 'success',
                        text: 'Зал був змінений!'
                    });

                    setTimeout(() => {
                        this.$router.push(
                            {
                                name: 'user.gyms.view',
                                params: {id: this.getNewGym.id}
                            }
                        );
                    }, 2000);
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/catalog/gym/edit.vue